export default function RemovePatientForm() {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-4 rounded-2xl border border-red-500/30 bg-content-dark/60 p-6 text-white shadow-inner shadow-red-500/20">
      <header className="space-y-1 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-red-300/80">Danger zone</p>
        <h2 className="text-2xl font-semibold tracking-tight text-white">Remove selected patients</h2>
      </header>
      <p className="text-center text-sm text-white/70">
        This action permanently removes the selected patients and all associated scans from the workspace. You will not be able to undo this
        operation.
      </p>
    </div>
  );
}
